<div class="min-resolution-modal"
  [ngClass]="{'whitelabel': whiteLabel !== 10, 'ranking': whiteLabel === 10, 'bg-center': whiteLabel === 2, 'bg-size-two': whiteLabel === 6, 'bg-left-zero': whiteLabel === 8 || whiteLabel === 9}">
  <div class="mobile-header"></div>
  <div class="blue-warning">
    <mat-icon svgIcon="monitor-resolution"></mat-icon>
    <span>
      <b>Ops!</b> Essa página não pode acessar essa resolução.
    </span>
  </div>

  <!-- WEB -->
  <div class="resolution-message" [ngClass]="{'whitelabel': whiteLabel !== 10, 'ranking': whiteLabel === 10}">
    <!-- Desafio -->
    <span class="title" *ngIf="whiteLabel === 10">{{ 'Olá Investidor' }}</span>
    <span class="message" *ngIf="whiteLabel === 1 || whiteLabel === 4">
      Baixe nosso aplicativo e aproveite em tempo real a plataforma independente e mais completa do mercado brasileiro.
    </span>
    <span class="message" *ngIf="whiteLabel === 10">
      Por enquanto, o Desafio de Investimentos é exclusivo para web. Por favor, acesse do seu desktop. Obrigado!
    </span>
    <div class="images" *ngIf="whiteLabel === 1 || whiteLabel === 4">
      <img src="./assets/images/assets/app-store.svg">
      <img src="./assets/images/assets/google-play.svg">
    </div>

    <!-- Default -->
    <div class="box-text-two" *ngIf="whiteLabel !== 10">
      <div class="title">Não fique triste :(</div>
      <div class="text">Em breve teremos um aplicativo completo para você operar no mercado de capitais.</div>
    </div>

  </div>

  <!-- MOBILE -->
  <div class="resolution-message mobile" [ngClass]="{'whitelabel': whiteLabel !== 10, 'ranking': whiteLabel === 10}">
    <!-- Desafio -->
    <span class="title" *ngIf="whiteLabel === 10">{{ 'Olá Investidor' }}</span>
    <span class="message" *ngIf="whiteLabel === 10">
      Por enquanto, o Desafio de Investimentos é exclusivo para web. Por favor, acesse do seu desktop. Obrigado!
    </span>
    <span class="message" *ngIf="whiteLabel === 1 || whiteLabel === 4">
      Baixe nosso aplicativo e aproveite em tempo real a plataforma independente e mais completa do mercado brasileiro.
    </span>
    <div class="images" *ngIf="whiteLabel === 1 || whiteLabel === 4">
      <img src="./assets/images/assets/app-store.svg">
      <img src="./assets/images/assets/google-play.svg">
    </div>

    <!-- Default -->
    <div class="box-text" *ngIf="whiteLabel !== 10 && whiteLabel !== 1 && whiteLabel !== 4">
      <span class="bold">Ops!</span>
      <span>&nbsp;Essa página não pode acessar essa resolução.</span>
    </div>
    <div class="box-text-two" *ngIf="whiteLabel !== 10 && whiteLabel !== 1 && whiteLabel !== 4">
      <div class="title">Não fique triste :(</div>
      <div class="text">Em breve teremos um aplicativo completo para você operar no mercado de capitais.</div>
    </div>

  </div>
</div>